import type { CSSProperties } from "react";
import { ButtonLink } from "../ui/ButtonLink";
import { homeHeroOverview } from "../../content/siteContent";
import { useAppStore } from "../../store/useAppStore";
import { cn } from "../../lib/cn";
import { getStudioToProjectsDollyProgress } from "../../webgl/transitions/sectionMotion";

export function StudioSection() {
  const setStudioHovered = useAppStore((state) => state.setStudioHovered);
  const currentSection = useAppStore((state) => state.currentSection);
  const targetSection = useAppStore((state) => state.targetSection);
  const isTransitioning = useAppStore((state) => state.isTransitioning);
  const transitionProgress = useAppStore((state) => state.transitionProgress);
  const isStudioProjectsTransition = currentSection === "studio" && targetSection === "projects" && isTransitioning;
  const studioCopyProgress = isStudioProjectsTransition ? getStudioToProjectsDollyProgress(transitionProgress) : 0;

  return (
    <section
      className="experience-section experience-section--studio"
      onMouseEnter={() => setStudioHovered(true)}
      onMouseLeave={() => setStudioHovered(false)}
    >
      <div className="section-panel--hero">
        <div
          className={cn("section-panel__copy", isStudioProjectsTransition && "section-panel__copy--transitioning")}
          style={
            isStudioProjectsTransition
              ? ({
                  "--studio-copy-progress": studioCopyProgress
                } as CSSProperties)
              : undefined
          }
        >
          <p className="section-panel__eyebrow">7 Stones Studio</p>
          <div className="space-y-3">
            <h2 className="section-panel__display">{homeHeroOverview.label}</h2>
          </div>
          <p className="section-panel__body">{homeHeroOverview.description}</p>
          <div className="section-panel__actions flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <ButtonLink to="/#projects">Explore projects</ButtonLink>
            <ButtonLink className="studio-secondary-cta" to="/#contact">
              Start a project
            </ButtonLink>
          </div>
        </div>
        <div aria-hidden="true" className="section-panel__mobileStage" />
      </div>
    </section>
  );
}
